import { createCommentary } from "/commentaries/commentary_functions.js";
import { createElement } from "/elements_functions/new_elements.js";
import { makeNewButtonAffectingDifferentElement } from '/buttons_functions/custom_button_functions.js';

export async function createCommentGroupWithPreloadedComments(commentariesAndNextInfo, commentFunctionsParam, nextPage) {

    const commentGroup = createElement('div', null, ['comment-group']);

    const commentariesInfo = commentariesAndNextInfo.commentaries;
    
    if(commentariesInfo===null || commentariesInfo===undefined || commentariesInfo.length===0) {
        const noCommentsCaption = createElement('p', null, ['comment-group-no-comment-caption']);
        noCommentsCaption.innerText = "there are no comments yet.";

        commentGroup.append(noCommentsCaption);

        commentGroup.noCommentsCaption = noCommentsCaption;

        return commentGroup;
    }

    if(!(commentFunctionsParam.commentGroupInitFunction instanceof Function))
        throw new Error("Not a function");

    const elementsToAppend = [];
    const commentElements = [];


    for(let i of commentariesInfo) {
        const commentElement = createCommentary(i, commentFunctionsParam);
        elementsToAppend.push(commentElement);
        commentElements.push(commentElement);
    }

    if(commentariesAndNextInfo.isThereMore===true) {

        const loadMoreCommentariesButton = createLoadCommentariesButtonWithPage(nextPage, commentFunctionsParam, commentGroup);
    
        elementsToAppend.push(loadMoreCommentariesButton);
        commentGroup.loadMoreCommentariesButton = loadMoreCommentariesButton;
    }

    console.log("elementsToAppend", elementsToAppend);
    
    commentGroup.append(...elementsToAppend);

    commentGroup.commentElements = commentElements;

    commentFunctionsParam.commentGroupInitFunction(commentGroup);

    return commentGroup;
}

function createLoadCommentariesButtonWithPage(page, commentFunctionsParam, insertElement) {
    const loadCommentariesButton = createElement('button', null, ['comment-group-load-comments']);
    const loadCommentariesButtonLine = createElement('div', null, ['comment-group-load-comments-line']);
    const loadCommentariesButtonWhiteSpace = createElement('div', null, ['comment-group-load-comments-white-space']);
    const loadCommentariesButtonCaption = createElement('p', null, ['comment-group-load-comments-caption']);

    makeNewButtonAffectingDifferentElement(loadCommentariesButton, loadCommentariesButtonLine, 'light-black', null, null, 'lighten', null);
    makeNewButtonAffectingDifferentElement(loadCommentariesButton, loadCommentariesButtonCaption, 'light-black', 'white', null, 'lighten', null);

    loadCommentariesButtonWhiteSpace.append(loadCommentariesButtonCaption);
    loadCommentariesButton.append(loadCommentariesButtonLine, loadCommentariesButtonWhiteSpace);

    loadCommentariesButtonCaption.innerText = 'More comments';

    loadCommentariesButton.addEventListener('click', () => {
        loadAndInsertComemntariesWithPage(page, commentFunctionsParam, insertElement);
        loadCommentariesButton.remove();
    });

    if(!(commentFunctionsParam.loadOriginalCommentariesButtonInitFunction instanceof Function))
        return new Error("Not a function");

    commentFunctionsParam.loadOriginalCommentariesButtonInitFunction(loadCommentariesButton);

    return loadCommentariesButton;

}

async function loadAndInsertComemntariesWithPage(page, commentFunctionsParam, insertElement) {

    if(!(commentFunctionsParam.fetchCommentariesInCommentGroupFunction instanceof Function))
        return new Error("Not a function");

    const commentariesAndNextInfo = await commentFunctionsParam.fetchCommentariesInCommentGroupFunction(page);
    const commentariesInfo = commentariesAndNextInfo.commentaries;
    const isThereMore = commentariesAndNextInfo.isThereMore;
    

    if(commentariesInfo===null || commentariesInfo.length===0)
        return null;

    const commentaries = [];

    for(let i of commentariesInfo) {
        const commentElement = createCommentary(i, commentFunctionsParam);
        commentaries.push(commentElement);
    }
    
    if(isThereMore===true) {
        const nextLoadButton = createLoadCommentariesButtonWithPage(page+1, commentFunctionsParam, insertElement);
        commentaries.push(nextLoadButton);
    }


    insertElement.append(...commentaries);
}